(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mahj-cart-drawer"] && !Shopify.designMode) return;
  try {
    
/* Shopify Ajax cart + section rendering. No checkout or price manipulation. */
(() => {
  if (customElements.get('mahj-cart-drawer')) return;

  const FALLBACK_CONFIG = {
    root: '/',
    cartUrl: '/cart',
    horizon: true,
    openOnAdd: true,
    messages: {
      updating: 'Updating your cart…',
      updated: 'Cart updated.',
      error: 'We could not update your cart. Please check your cart before trying again.',
      refreshError: 'We could not refresh your cart. Open your cart to check the latest items.'
    }
  };

  class MahjCartDrawer extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.dialog = this.querySelector('dialog');
      if (!this.dialog) return;
      this.dialog.id = `MahjCartDialog-${this.dataset.sectionId}`;
      this.config = this.readConfig();
      this.controller = new AbortController();
      this.busy = false;
      this.revision = 0;
      this.externalOperations = new Set();
      const options = { signal: this.controller.signal };
      this.addEventListener('click', this.onClick, options);
      this.addEventListener('submit', this.onSubmit, options);
      this.dialog.addEventListener('close', this.onClose, options);
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.close();
      }, options);
      document.addEventListener('click', this.onOpenClick, { ...options, capture: true });
      document.addEventListener('submit', this.onProductSubmit, { ...options, capture: true });
      document.addEventListener('mahj:cart:open', this.onOpenEvent, options);
      document.addEventListener('mahj:cart:refresh', this.onRefreshEvent, options);
      window.addEventListener('pageshow', (event) => { if (event.persisted && this.dialog.open) this.refresh(); }, options);

      if (this.dataset.designMode === 'true') {
        const selected = (event) => event.detail?.sectionId === this.dataset.sectionId || this.contains(event.target);
        document.addEventListener('shopify:section:select', (event) => { if (selected(event)) this.open({ refresh: false }); }, options);
        document.addEventListener('shopify:block:select', (event) => { if (selected(event)) this.open({ refresh: false }); }, options);
        document.addEventListener('shopify:section:load', (event) => { if (selected(event)) this.open({ refresh: false }); }, options);
        document.addEventListener('shopify:section:deselect', (event) => { if (selected(event)) this.close(); }, options);
        if (sessionStorage.getItem('mahj-editor-open') === this.dataset.sectionId) this.open({ refresh: false });
      }

      // Let the previous section instance finish restoring its triggers first.
      // This also works when Horizon's events module is unavailable.
      if (this.config.horizon) {
        const controller = this.controller;
        queueMicrotask(() => {
          if (this.isConnected && this.controller === controller) this.adaptTriggers();
        });
        this.connectHorizon();
      }
      this.connectGemPages();
    }

    disconnectedCallback() {
      this.close();
      document.documentElement.classList.remove('mcd-scroll-lock');
      this.controller?.abort();
      this.refreshController?.abort();
      this.horizonObserver?.disconnect();
      this.countObserver?.disconnect();
      this.restoreHorizon?.();
      clearTimeout(this.gemConnectTimer);
      this.gemQuery?.(document).off('addToCartSuccess.gfaction.mahjCart', this.onGemPagesAdd);
      this.gemQuery = null;
      this.triggersAdapted = false;
      this.countObserver = null;
      this.controller = null;
      this.revision++;
    }

    readConfig() {
      const node = this.querySelector('[data-mcd-config]');
      if (!node) return { ...FALLBACK_CONFIG };
      try {
        const parsed = JSON.parse(node.textContent);
        return { ...FALLBACK_CONFIG, ...parsed, messages: { ...FALLBACK_CONFIG.messages, ...(parsed.messages || {}) } };
      } catch (error) {
        console.warn('[Mahj cart] config non valido: uso i valori di default.', error);
        return { ...FALLBACK_CONFIG };
      }
    }

    /* ---------- Theme integration (Horizon) ---------- */
    adaptTriggers() {
      if (this.triggersAdapted) return;
      this.triggersAdapted = true;
      this.modifiedTriggers = new Map();
      this.nativeAutoOpen = new Map();
      this.adapt();
      this.horizonObserver = new MutationObserver(() => this.adapt());
      this.horizonObserver.observe(document.body, { subtree: true, childList: true });
      this.restoreHorizon = () => {
        this.modifiedTriggers.forEach((original, node) => {
          if (!node.isConnected) return;
          if (original.action) node.setAttribute('on:click', original.action);
          node.removeAttribute('data-mahj-cart-open');
          if (original.controls) node.setAttribute('aria-controls', original.controls);
          node.setAttribute('aria-expanded', 'false');
        });
        this.nativeAutoOpen.forEach((_, node) => { if (node.isConnected) node.setAttribute('auto-open', ''); });
      };
    }

    adapt = () => {
      document.querySelectorAll('[data-testid="cart-drawer-trigger"], [on\\:click*="#cart-drawer"]').forEach((node) => {
        const action = node.getAttribute('on:click');
        if (action && !['#cart-drawer/toggle', '#cart-drawer/open'].includes(action)) return;
        if (!this.modifiedTriggers.has(node)) this.modifiedTriggers.set(node, { action, controls: node.getAttribute('aria-controls') });
        node.removeAttribute('on:click');
        node.setAttribute('data-mahj-cart-open', '');
        node.setAttribute('aria-controls', this.dialog.id);
        node.setAttribute('aria-expanded', String(this.dialog.open));
      });
      document.querySelectorAll('#cart-drawer cart-drawer-component[auto-open]').forEach((node) => {
        this.nativeAutoOpen.set(node, true);
        node.removeAttribute('auto-open');
      });
    };

    connectGemPages() {
      // GemPages V6 gfv3product.js emits this jQuery event only after add.js succeeds.
      // In GemPages enable Ajax Cart > Custom, with the Custom URL left blank.
      const controller = this.controller;
      const attach = () => {
        if (!this.isConnected || this.controller !== controller || this.gemQuery || !window.GemQuery?.fn?.on) return;
        this.gemQuery = window.GemQuery;
        this.gemQuery(document).on('addToCartSuccess.gfaction.mahjCart', this.onGemPagesAdd);
      };
      attach();
      // GemPages can load its own jQuery asynchronously after the theme scripts.
      document.addEventListener('load', (event) => {
        if (this.gemQuery || !(event.target instanceof HTMLScriptElement)) return;
        clearTimeout(this.gemConnectTimer);
        this.gemConnectTimer = setTimeout(attach, 0);
      }, { capture: true, signal: controller.signal });
      window.addEventListener('load', attach, { once: true, signal: controller.signal });
    }

    onGemPagesAdd = async () => {
      if (!this.isConnected || this.dataset.designMode === 'true') return;
      const controller = this.controller;
      const operation = {};
      const revision = this.gemRevision = (this.gemRevision || 0) + 1;
      this.externalOperations.add(operation);
      this.syncLocks();
      if (this.config.openOnAdd) this.open({ refresh: false });
      try {
        // GemPages already added the item. Read only; never submit the form again.
        const response = await fetch(this.endpoint('cart.js'), {
          credentials: 'same-origin', cache: 'no-store',
          headers: { Accept: 'application/json' }, signal: controller.signal
        });
        if (!response.ok) throw new Error(this.config.messages.refreshError);
        const cart = await response.json();
        if (!this.isConnected || this.controller !== controller || this.gemRevision !== revision) return;
        // Also update Horizon's header count and other cart components.
        this.dispatchEvent(new CustomEvent('mahj:cart:updated', {
          bubbles: true, detail: { cart, action: 'add', lines: [], source: 'gempages' }
        }));
      } catch (_) {
        // The section refresh below still reconciles the drawer after a failed GET.
      } finally {
        if (this.controller === controller) {
          this.externalOperations.delete(operation);
          this.pendingRefresh = true;
          this.syncLocks();
          if (!this.locked && this.isConnected) { this.pendingRefresh = false; this.refresh(); }
        }
      }
    };

    async connectHorizon() {
      let events;
      try { events = await import('@shopify/events'); }
      catch (_) {
        console.warn('[Mahj cart] Horizon Standard Events non disponibili: attivo il fallback sul contatore del carrello.');
        this.watchCartCount();
        return;
      }
      if (!this.isConnected) return;
      const { StandardEvents, CartLinesUpdateEvent } = events;
      const options = { signal: this.controller.signal };
      document.addEventListener(StandardEvents.cartLinesUpdate, async (event) => {
        if (event.target === this || !event.promise) return;
        const sourceDialog = event.target instanceof Element ? event.target.closest('dialog[open]') : null;
        this.externalOperations.add(event);
        this.syncLocks();
        try {
          const result = await event.promise;
          if (!this.isConnected) return;
          if (!result.detail?.didError && event.action === 'add' && this.config.openOnAdd) {
            const show = () => { if (this.isConnected) this.open(); };
            if (sourceDialog?.open) sourceDialog.addEventListener('close', show, { once: true, signal: this.controller.signal });
            else show();
          }
          this.pendingRefresh = true;
        } catch (_) { this.pendingRefresh = true; }
        finally {
          this.externalOperations.delete(event);
          this.syncLocks();
          if (!this.locked && this.pendingRefresh && this.isConnected) { this.pendingRefresh = false; this.refresh(); }
        }
      }, options);
      this.addEventListener('mahj:cart:updated', (event) => {
        const cart = event.detail.cart;
        this.dispatchEvent(new CartLinesUpdateEvent({
          action: event.detail.action, context: 'cart', lines: event.detail.lines,
          promise: Promise.resolve({
            cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
            detail: { source: event.detail.source || 'mahj-drawer', itemCount: cart.item_count, items: cart.items }
          })
        }));
      }, options);
    }

    /* Fallback senza Standard Events: apre il drawer quando il contatore articoli aumenta. */
    watchCartCount() {
      if (this.countObserver || !this.config.openOnAdd || this.dataset.designMode === 'true') return;
      const read = () => {
        const node = document.querySelector('[data-testid="cart-count"], .cart-count-bubble, [data-cart-count], .cart-count');
        if (!node) return null;
        const value = parseInt((node.textContent || '').replace(/\D+/g, ''), 10);
        return Number.isFinite(value) ? value : null;
      };
      let last = read();
      this.countObserver = new MutationObserver(() => {
        const next = read();
        if (next === null) return;
        if (last !== null && next > last && !this.locked && !this.dialog.open) this.open();
        last = next;
      });
      this.countObserver.observe(document.body, { subtree: true, childList: true });
    }

    /* ---------- Core ---------- */
    get demo() { return this.querySelector('[data-mcd-content]')?.dataset.demo === 'true'; }
    get locked() { return this.busy || this.externalOperations.size > 0; }
    endpoint(path) { return `${this.config.root.replace(/\/$/, '')}/${path}`; }

    onOpenClick = (event) => {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const trigger = event.target instanceof Element ? event.target.closest('[data-mahj-cart-open]') : null;
      if (!trigger) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      this.open({ trigger });
    };
    onOpenEvent = () => this.open();
    onRefreshEvent = () => this.refresh();

    open({ trigger, refresh = true } = {}) {
      if (!this.dialog.open) {
        this.returnFocus = trigger || document.activeElement;
        this.dialog.showModal();
        document.documentElement.classList.add('mcd-scroll-lock');
        this.querySelector('[data-mcd-close]')?.focus({ preventScroll: true });
        document.querySelectorAll('[data-mahj-cart-open]').forEach((node) => node.setAttribute('aria-expanded', 'true'));
      }
      if (this.dataset.designMode === 'true') sessionStorage.setItem('mahj-editor-open', this.dataset.sectionId);
      if (refresh && this.dataset.designMode !== 'true') return this.refresh();
      return Promise.resolve();
    }

    close() { if (this.dialog?.open) this.dialog.close(); }

    onClose = () => {
      document.documentElement.classList.remove('mcd-scroll-lock');
      document.querySelectorAll('[data-mahj-cart-open]').forEach((node) => node.setAttribute('aria-expanded', 'false'));
      if (this.returnFocus?.isConnected) this.returnFocus.focus?.({ preventScroll: true });
      if (this.dataset.designMode === 'true' && this.isConnected) sessionStorage.removeItem('mahj-editor-open');
    };

    onClick = (event) => {
      const button = event.target instanceof Element ? event.target.closest('button') : null;
      if (!button || !this.contains(button)) return;
      if (button.hasAttribute('data-mcd-close')) { this.close(); return; }
      if (!button.hasAttribute('data-mcd-mutate')) return;
      if (this.locked || button.disabled) return;
      if (this.demo) { this.announce('Anteprima editor: nessuna modifica al carrello.'); return; }
      if (button.dataset.mcdVariant) {
        this.mutate('cart/add.js', { items: [{ id: button.dataset.mcdVariant, quantity: Number(button.dataset.mcdAddQuantity) || 1 }] }, 'add');
      } else if (button.dataset.mcdKey) {
        this.mutate('cart/change.js', { id: button.dataset.mcdKey, quantity: Number(button.dataset.mcdQuantity) }, 'update');
      }
    };

    onSubmit = (event) => {
      if (event.target.matches('[data-mcd-checkout-form]') && (this.locked || this.demo)) event.preventDefault();
    };

    onProductSubmit = (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !form.matches('[data-mahj-cart-form]')) return;
      if (event.submitter?.name === 'checkout' || !form.checkValidity()) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (this.locked) return;
      const data = new FormData(form);
      this.open({ refresh: false, trigger: event.submitter });
      this.mutate('cart/add.js', data, 'add');
    };

    announce(message) { this.querySelector('[data-mcd-status]').textContent = message; }
    error(message) {
      const box = this.querySelector('[data-mcd-error]');
      if (!box) return;
      box.hidden = !message;
      const text = this.querySelector('[data-mcd-error-text]');
      if (text) text.textContent = message || '';
    }
    setBusy(value) {
      if (value && !this.busy) this.restoreFocusKey = this.contains(document.activeElement) ? document.activeElement.dataset.mcdFocus : null;
      this.busy = value;
      this.syncLocks();
    }
    syncLocks() {
      this.querySelector('[data-mcd-content]')?.setAttribute('aria-busy', String(this.locked));
      this.querySelectorAll('[data-mcd-mutate], [data-mcd-checkout]').forEach((button) => {
        if (this.locked && !button.disabled) { button.dataset.mcdBusyDisabled = 'true'; button.disabled = true; }
        if (!this.locked && button.dataset.mcdBusyDisabled) { button.disabled = false; delete button.dataset.mcdBusyDisabled; }
      });
    }

    applyMarkup(html) {
      if (typeof html !== 'string' || !html.trim()) return false;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const root = doc.getElementById(this.id);
      const incoming = root?.querySelector('[data-mcd-content]');
      if (!incoming) return false;
      const current = this.querySelector('[data-mcd-content]');
      const scroll = current.querySelector('[data-mcd-scroll]')?.scrollTop || 0;
      const focused = current.contains(document.activeElement) || Boolean(this.restoreFocusKey);
      const focusKey = this.restoreFocusKey || (focused ? document.activeElement.dataset.mcdFocus : null);
      current.replaceWith(incoming);
      const heading = this.querySelector('[data-mcd-heading]');
      if (heading) heading.textContent = (heading.dataset.mcdHeadingTemplate || '').replace('[count]', incoming.dataset.count || '0');
      const count = this.querySelector('[data-mcd-count]');
      if (count) count.textContent = incoming.dataset.count || '0';
      this.querySelector('[data-mcd-scroll]').scrollTop = scroll;
      this.syncLocks();
      if (focused && this.dialog.open) {
        const next = focusKey ? [...incoming.querySelectorAll('[data-mcd-focus]')].find((node) => node.dataset.mcdFocus === focusKey) : null;
        this.nextFocus = next || this.querySelector('[data-mcd-close]');
      }
      return true;
    }

    async fetchMarkup(signal) {
      const url = new URL(window.location.href);
      url.hash = '';
      url.searchParams.delete('sections');
      url.searchParams.set('section_id', this.dataset.sectionId);
      const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', signal });
      if (!response.ok) throw new Error(this.config.messages.refreshError);
      const html = await response.text();
      if (signal?.aborted) return;
      if (!this.applyMarkup(html)) throw new Error(this.config.messages.refreshError);
    }

    async refresh() {
      if (this.dataset.designMode === 'true') return;
      if (this.locked) { this.pendingRefresh = true; return; }
      this.setBusy(true);
      this.error('');
      this.refreshController = new AbortController();
      try { await this.fetchMarkup(this.refreshController.signal); }
      catch (error) { if (error.name !== 'AbortError') this.error(this.config.messages.refreshError); }
      finally { this.finish(); }
    }

    async mutate(path, payload, action) {
      if (this.locked || this.demo) return;
      this.setBusy(true);
      this.error('');
      this.announce(this.config.messages.updating);
      const revision = ++this.revision;
      const sectionId = this.dataset.sectionId;
      const sectionUrl = window.location.pathname + window.location.search;
      const multipart = payload instanceof FormData;
      const lines = action === 'add'
        ? (multipart ? [{ merchandiseId: payload.get('id'), quantity: Number(payload.get('quantity')) || 1 }] : payload.items.map((item) => ({ merchandiseId: item.id, quantity: item.quantity })))
        : [{ id: payload.id, quantity: payload.quantity }];
      if (multipart) { payload.set('sections', sectionId); payload.set('sections_url', sectionUrl); }
      else payload = { ...payload, sections: [sectionId], sections_url: sectionUrl };
      try {
        const response = await fetch(this.endpoint(path), {
          method: 'POST', credentials: 'same-origin',
          headers: multipart ? { Accept: 'application/json' } : { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: multipart ? payload : JSON.stringify(payload)
        });
        const result = await response.json();
        if (!response.ok || result.status >= 400) throw new Error(typeof result.description === 'string' ? result.description : this.config.messages.error);
        if (!this.isConnected || revision !== this.revision) return;
        if (!this.applyMarkup(result.sections?.[sectionId])) await this.fetchMarkup();
        const cartResponse = await fetch(this.endpoint('cart.js'), { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
        if (!cartResponse.ok) throw new Error(this.config.messages.refreshError);
        const cart = await cartResponse.json();
        this.announce(this.config.messages.updated);
        this.dispatchEvent(new CustomEvent('mahj:cart:updated', { bubbles: true, detail: { cart, action, lines, source: 'mahj-drawer' } }));
      } catch (error) {
        if (!this.isConnected) return;
        try { await this.fetchMarkup(); } catch (_) { /* Keep the cart-page recovery link visible. */ }
        this.error(error instanceof TypeError ? this.config.messages.error : error.message || this.config.messages.error);
        this.announce('');
      } finally { this.finish(); }
    }

    finish() {
      this.setBusy(false);
      if (this.dialog.open && this.nextFocus?.isConnected) this.nextFocus.focus({ preventScroll: true });
      this.nextFocus = null;
      this.restoreFocusKey = null;
      if (this.pendingRefresh && !this.locked && this.isConnected) {
        this.pendingRefresh = false;
        this.refresh();
      }
    }
  }

  customElements.define('mahj-cart-drawer', MahjCartDrawer);
  window.MahjCart = {
    open: () => document.querySelector('mahj-cart-drawer')?.open(),
    close: () => document.querySelector('mahj-cart-drawer')?.close(),
    refresh: () => document.querySelector('mahj-cart-drawer')?.refresh()
  };
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
